module.exports = __webpack_public_path__ + "static/media/Play.038587ba.png";